import React, {useEffect, useRef, useState} from "react";
import axios from 'axios';

const NotificationComponent = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
    //fetch("http://localhost:8080/owl/cmi1000e.mics?mode=doGetNotification&value1=OWL&value2=RC-LS")
    let URL = "https://rc.owl-checker.com/owl/cmi1000e.mics?mode=doNotificationList";
    //let URL = "https://rc.checkeyedx.com/owl/cmi1000e.mics?mode=doNotificationList"; // Checkeye-DX
    // let URL = "http://localhost:8085/owl/cmi1000e.mics?mode=doNotificationList";   // LOCAL-TEST

        console.log("FETCH URL : " + URL);
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {
                console.log("notice data : " + data.LIST[0].content);
                const notificationsWithExpandedState = data.LIST.map((item) => ({
                    ...item,
                    expanded: false, // 각 항목에 expanded 상태 추가
                }));
                setNotifications(notificationsWithExpandedState || []);
            })
            .catch(() => {
                setNotifications([]);
            });
    }, []); // 빈 배열을 두 번째 인자로 전달하여 컴포넌트가 처음 렌더링될 때만 실행되도록 설정

    const toggleExpand = (index) => {
        const updatedNotifications = [...notifications];
        updatedNotifications[index].expanded = !updatedNotifications[index].expanded;
        setNotifications(updatedNotifications);
    };

    return (
        <div className="notice-body">
            <div style={{ width: '100%', alignContent: 'left', marginLeft: '8px' }}>
                <table ><tr><td rowSpan={2}
                                 style={{ backgroundColor: '#A4C8F0', width: '5px' }}></td>
                <td className="notice-sub-title">&nbsp;&nbsp;&nbsp;Information</td></tr>
            <tr><td className="notice-title">&nbsp;お知らせ</td></tr></table></div>
            <div className="wrap">
                <table className="custom-table">
                    <tbody>
                    {notifications.map((item, index) => {
                        const startDtFormat = "■" +
                            item.start_dt.substring(2, 4) +
                            "/" +
                            item.start_dt.substring(4, 6) +
                            "/" +
                            item.start_dt.substring(6, 8);

                        if ( chkDateTime( item.start_dt, item.end_dt ) ){
                        return (
                            <tr key={index}>
                                <th>{startDtFormat}</th>
                                {/*<td*/}
                                {/*    className={`content-cell ${item.expanded ? "expanded" : ""}`}*/}
                                {/*    onClick={() => toggleExpand(index)}*/}
                                {/*>*/}
                                {/*    /!* 컨텐츠가 유효한 HTML인 경우에만 dangerouslySetInnerHTML 사용 *!/*/}
                                {/*    {item.content ? (*/}
                                {/*        <div dangerouslySetInnerHTML={{ __html: item.content }} />*/}
                                {/*    ) : (*/}
                                {/*        <div>No content available</div> // 컨텐츠가 없을 경우 대체 텍스트*/}
                                {/*    )}*/}
                                {/*    {!item.expanded && (*/}
                                {/*        <span className="toggle-btn">[続きを読む]</span>*/}
                                {/*    )}*/}
                                {/*    {item.expanded && (*/}
                                {/*        <span className="toggle-btn">[閉じる]</span>*/}
                                {/*    )}*/}
                                {/*</td>*/}
                                <ExpandableRow key={index} date={startDtFormat} content={item.content} />
                            </tr>
                        );
                        } else {
                            console.log(" date chk "+ item.start_dt);
                        }
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};



function ExpandableRow({ date, content }) {
    const [isExpandable, setIsExpandable] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight);
            const maxHeight = lineHeight * 3; // 3줄 기준 높이
            if (contentRef.current.scrollHeight > maxHeight) {
                setIsExpandable(true);
            }
        }
    }, []);

    return (
            <td className={`content-cell ${isExpanded ? "expanded" : ""}`} ref={contentRef}>
                <div dangerouslySetInnerHTML={{ __html: content }} />
                {isExpandable && (
                    <span
                        className="toggle-btn"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? "[閉じる] " : "[続きを読む] "}
                    </span>
                )}
            </td>
    );
}


//-------------------------------------------------------------
// 공지 기간 확인
//-------------------------------------------------------------
function chkDateTime(frdt, todt ){
    console.log ( "isServerWorking ....") ;
    const today = new Date(); // 현재 날짜를 가져옵니다.
    let year = today.getFullYear(); //년도 구하기
    let month = (today.getMonth()+1);
    let day = today.getDate();
    let hour = today.getHours();
    month = month >= 10 ? month : '0' + month;
    day = day >= 10 ? day : '0' + day;
    hour = hour >= 10 ? hour : '0' + hour;
    const todayTime = year + '' + month + '' + day + '' + hour ;
    console.log ("chkDateTime -> todayTime : " +todayTime,
        ", frdt ->" + frdt +", todt :" + todt) ;
    if ( (parseInt(todayTime) >= parseInt(frdt)) && (parseInt(todayTime) <= parseInt(todt))) {
        console.log("공지 가능 시간입니다." );
        return true ;
    }else {
        console.log("공지 불가 합니다. " );
        return false ;
    }
}
export default NotificationComponent;
